import { Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';

import { Grid2 } from '@mui/material';
import FormFields from 'pages/components/FormFields';
import Section from 'pages/components/Section';

export default function References(props: any) {
  const { values, handleInputChange, isMobile, formatErrorObject, errors } =
    props;

  const { t } = useTranslation();
  
  return (
    <Section title={'references'}>
      <Grid2
        width={'100%'}
        gap={2}
        display="grid"
        gridTemplateColumns={isMobile ? '1fr' : 'repeat(2, 1fr)'}
      >
        <FormFields.TextInput
          name="externalIdentifier"
          label={values.country + '-externalIdentifier'}
          placeholder={values.country + '-externalIdentifier'}
          value={values.externalIdentifier}
          onChange={handleInputChange}
          required
          {...formatErrorObject(errors.externalIdentifier)}
        />

        {/* <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}> */}
          <FormFields.TextInput
            name="iban"
            value={values.iban}
            onChange={handleInputChange}
            required
            {...formatErrorObject(errors.iban)}
          />
          {/* <Tooltip
            slotProps={{
              tooltip: {
                sx: {
                  maxWidth: 'none',
                  whiteSpace: 'pre-wrap',
                  fontSize: '0.875rem',
                },
              },
            }}
            title={<pre>{t('FEATURE.explain_iban')}</pre>}
            placement="top"
            arrow={true}
          >
            <InfoIcon />
          </Tooltip> */}
        {/* </div> */}
      </Grid2>
    </Section>
  );
}
